import React, { Component } from 'react'
import { connectSortBy } from 'react-instantsearch-dom'
import SimpleAccordion from '../../../shared/filter-accordion'
class DropdownSortBy extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedRefinement: `Sort By`
    }

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(event, item, refine) {
    if (event) {
      const { isRefined, label, value } = item

      event.preventDefault()
      this.setState({ selectedRefinement: item.label })
      this.props.changeResultsIndex(item.value)
      refine(value)
    }
  }

  render() {
    const {
      items,
      currentRefinement,
      refine,
      dropdownState,
      dropdown,
      label,
      expanded,
      createURL
    } = this.props
    return (
      <div className={`mobile-custom-sortby`}>
        <SimpleAccordion
          title={this.state.selectedRefinement}
          expanded={expanded}
        >
          <div className="sort-by-content foreground-dark-green">
            <div className="options">
              <ul>
                {items.map(item => (
                  <li
                    className="sort-by-item"
                    key={item.value + `mobile_refinement`}
                    onClick={event => this.handleClick(event, item, refine)}
                  >
                    <a
                      className="sort-by-item-text"
                      href={`#${item.value}`}
                      style={{
                        fontWeight:
                          this.state.selectedRefinement === item.label
                            ? `bold`
                            : ``
                      }}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </SimpleAccordion>
      </div>
    )
  }
}

const CustomDropdownSortby = connectSortBy(DropdownSortBy)

export default CustomDropdownSortby
